import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'labelFromValue',
})
export class LabelFromValuePipe implements PipeTransform {
  transform(
    value: string | string[] | null | undefined,
    options: { label: string; value: string }[],
  ): string {
    if (!value) return '-';

    if (Array.isArray(value)) {
      return value.map((v) => options.find((opt) => opt.value === v)?.label || v).join(', ');
    }

    return options.find((opt) => opt.value === value)?.label || value;
  }
}
